<template>
  <div :style="{height: gap}"></div>
</template>
<script>
export default {
    data: function () {return {}},
    props:{
        w: String,
        x1: Boolean,
        x2: Boolean,
        x3: Boolean,
        x4: Boolean,
        x5: Boolean,
        x6: Boolean,
        x7: Boolean,
        x8: Boolean,
        
        small: Boolean,
        medium: Boolean,
        big: Boolean,
      },
      computed: {
        gap(){
            if (this.x1) return '2vh'
            if (this.x2) return '4vh'
            if (this.x3) return '8vh'
            if (this.x4) return '10vh'
            if (this.x5) return '12vh'
            if (this.x6) return '14vh'
            if (this.x7) return '16vh'
            if (this.x8) return '18vh'
            
            if (this.small) return '2vh'
            if (this.medium) return '8vh'
            if (this.big) return '16vh'
            
            if (this.w) return this.w
            return '5.5vh'
        },
      },
}
</script>